import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { artistInitialState } from "./states";
import axios from "axios";

const initialState = artistInitialState;

export const fetchArtistAsync = createAsyncThunk(
  "artists/Async",
  async (input, thunkApi) => {
    const { successCallback, errorCallback } = input;
    const { getState, rejectWithValue } = thunkApi;
    const { admin, artists } = getState();

    const config = {
      headers: {
        authorization: `Bearer ${admin.accessToken}`
      }
    };

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_END_POINT}admin/getAllArtists?index=${artists?.index}&limit=${artists?.limit}&search=${artists?.search}&activated=${artists?.filters.approved}&verified=${artists?.filters.verified}&spotlighted=${artists?.filters.spotlighted}&new_artist=${artists?.filters.new_artist}&reported=${artists?.filters.reported}`,
        config
      );
      if (successCallback && typeof successCallback === "function") {
        successCallback();
      }
      return {
        artists: response.data.content,
        totalCount: response.data.totalArtists
      };
    } catch (error) {
      errorCallback(error);
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchAllArtistsForExport = createAsyncThunk(
  "artists/export",
  async (input, thunkApi) => {
    const { successCallback, errorCallback } = input;
    const { getState, rejectWithValue } = thunkApi;
    const { admin } = getState();

    const config = {
      headers: {
        authorization: `Bearer ${admin.accessToken}`,
      },
    };

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_END_POINT}admin/getAllArtists?limit=99999`,
        config
      );
      if (successCallback && typeof successCallback === "function") {
        successCallback();
      }
      return response.data.content;
    } catch (error) {
      if (errorCallback) errorCallback(error);
      return rejectWithValue(error.response.data);
    }
  }
);

export const ArtistSlice = createSlice({
  name: "artists",
  initialState,
  reducers: {
    verified: (state, action) => {
      const { id, newData } = action.payload;
      const index = state.value.findIndex((bizz) => bizz._id === id);
      if (index !== -1) {
        state.value[index] = {
          ...state.value[index],
          ...newData
        };
      }
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    setIndex: (state, action) => {
      state.index = action.payload;
    },
    setApproved: (state, action) => {
      state.filters.approved = action.payload;
    },
    setNewArtist: (state, action) => {
      state.filters.new_artist = action.payload;
    },
    setVerified: (state, action) => {
      state.filters.verified = action.payload;
    },
    setSpotlighted: (state, action) => {
      state.filters.spotlighted = action.payload;
    },
    setReported: (state, action) => {
      state.filters.reported = action.payload;
    },
    setSearchText: (state, action) => {
      state.search = action.payload;
    },
    clearFilter: (state) => {
      state.index = 0;
      state.filters.approved = null;
      state.filters.new_artist = true;
      state.filters.reported = false;
      state.filters.verified = null;
      state.filters.spotlighted = null;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchArtistAsync.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchArtistAsync.fulfilled, (state, action) => {
      state.isLoading = false;
      state.value = action.payload.artists;
      state.totalCount = action.payload.totalCount;
    });
    builder.addCase(fetchArtistAsync.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  }
});

export default ArtistSlice.reducer;
export const {
  verified,
  setIndex,
  setLimit,
  setApproved,
  setNewArtist,
  setVerified,
  setSpotlighted,
  clearFilter,
  setReported,
  setSearchText
} = ArtistSlice.actions;
